import React, { useState, useEffect } from "react";
import Arrow from "../../assets/Ve.png";
import { useNavigate } from "react-router-dom";
import "./pendingPickup.css"
const PendingPickup = ({activeOrders,preCart, page}) => {
  const [expanded, setExpanded] = useState(false);
  const [timeLeft, setTimeLeft] = useState({});
  const navigate = useNavigate();
    const handleNavigate = (orderid) => {
    
    navigate(`/pickupOptions/${orderid}`);
  };


  const orders = activeOrders&&activeOrders;

  // ⏱️ Timer setup for each order
  useEffect(() => {
    const timer = setInterval(() => {
      const updatedTimes = {};
      orders.forEach((order) => {
        const now = new Date().getTime();
        const pickupTime = new Date(order.pickupTime).getTime();
        let diff = Math.max(0, pickupTime - now);

        const minutes = Math.floor(diff / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);

        updatedTimes[order.orderId] = `${minutes}:${seconds
          .toString()
          .padStart(2, "0")}`;
      });
      setTimeLeft(updatedTimes);
    }, 1000);

    return () => clearInterval(timer);
  }, [orders]);

  if (orders.length === 0) return null;
//console.log(" preCart&&preCart[0]", activeOrders&&activeOrders.length,)
  return (
    <div
    style={{
    display: "flex",
    position: "fixed",
    justifyContent: "center",
    width: "100%",
    zIndex: 999, // you can use number (no need for quotes)
 bottom:
    page === "vmlist"
      ? preCart?.[0] && activeOrders?.length > 1
        ? "125px":
         preCart?.[0] && activeOrders
        ? "148px"
        : preCart?.[0]
        ? "65px"
        : activeOrders
        ? expanded?"65px": activeOrders&&activeOrders?.length>1?"60px":"90px"
        : "10px"
      :preCart?.[0] && activeOrders?.length > 1
      ?"40px":
       preCart?.[0] && activeOrders
      ? "65px"
      : preCart?.[0]
      ? "65px"
      : activeOrders
      ? "10px"
      : "10px",
  }}

    >
      <div>
        <div className="pending-wrapper">
          {/* Compact View */}
          {!expanded && (
            <div className="pending-pickup" >
              <div className="image-stack">
                {orders[0].lineItems.slice(0, 2).map((item, index) => (
                  <img
                    key={index}
                    src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${item.imageUrl}`}
                    alt={item.productName}
                    className="stacked-img"
                    style={{ left: `${index * 20}px` }}
                  />
                ))}
              </div>

              <div className="details">
                <h3>Pending Pickup</h3>
                <p>
                  Pickup In{" "}
                  <span className="timer">
                    {timeLeft[orders[0].orderId] || "00:00"}
                  </span>{" "}
                  mins Or Order Cancels
                </p>
                <p>
                  <b>10%</b> Cancellation Fee Applies
                </p>
              </div>

                           <div className="action-btn" onClick={(e)=>{handleNavigate(orders[0].orderId)}}>
      <img src={Arrow} style={{ width: "10px" }} alt="arrow" />
    </div>
            </div>
          )}
        </div>

        {/* More Badge */}
        <div
          style={{
            display: "flex",
            position: "relative",
            justifyContent: "center",
            top: page=="vmlist"?"-100px":"-100px",
          }}
        >
          {!expanded && orders.length > 1 && (
            <div className="more-badge"onClick={() => setExpanded(true)} >+ {orders.length - 1} more pickups</div>
          )}
        </div>
      </div>

      {/* Expanded Overlay */}
      {expanded && (
        <div className="overlay">
          <div
            style={{
              width: "92%",
              position: "absolute",
              bottom:page=="vmlist"?(expanded?(preCart[0]?"136px":"80px"):"56px"):(expanded?(preCart?"54px":"0px"):"70px"),
              marginLeft:page=="vmlist"?"0":"0"
            }}
          >
            {/* Close button floating above popup */}
            <button className="close-btn" onClick={() => setExpanded(false)}>
              ✕
            </button>
            <div className="expanded-list">
              {orders.map((order) => (
                <div className="pending-pickup" key={order.orderId}>
                  <div className="image-stack">
                    {order.lineItems.slice(0, 2).map((item, idx) => (
                      <img
                        key={idx}
                        src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${item.imageUrl}`}
                        alt={item.productName}
                        className="stacked-img"
                        style={{ left: `${idx * 20}px` }}
                      />
                    ))}
                  </div>
                  <div className="details">
                    <h3>Pending Pickup</h3>
                    <p>
                      Pickup In{" "}
                      <span className="timer">
                        {timeLeft[order.orderId] || "00:00"}
                      </span>{" "}
                      mins Or Order Cancels
                    </p>
                    <p>
                      <b>10%</b> Cancellation Fee Applies
                    </p>
                  </div>
                            <div className="action-btn" onClick={(e)=>{handleNavigate(order&&order.orderId)}}>
      <img src={Arrow} style={{ width: "10px" }} alt="arrow" />
    </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PendingPickup;
